// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@awc/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { filterStyles } from "@awc/Overrides/Widgets/InvoiceHistory/InvoiceHistoryFilter";
import { constants } from "@awc/XDL/constants";
import { hideElement, mergeWithCss, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

filterStyles.container = {
    ...myAccountFilterSectionStyles.filterContainer,
};

filterStyles.headingItem = {
    css: css`
        ${hideElement}
    `,
};

filterStyles.clearFiltersButton = {
    ...myAccountFilterSectionStyles.clearButton,
};

filterStyles.buttonsItem = {
    width: [12, 12, 12, 9, 9],
    css: css`
        &&& {
            margin-left: auto;
            justify-content: flex-end;
            align-items: flex-end;
        }
    `,
};

filterStyles.onlyOpenGridItem = {
    width: [12, 12, 12, 4, 4],
    align: "middle",
    css: css`
        > div {
            ${xScreen("lte", "md")} {
                margin-top: 0;
            }
        }
    `,
};

filterStyles.shipToGridItem = {
    width: [12, 12, 12, 4, 4],
};

filterStyles.invoiceNumberGridItem = {
    width: [12, 12, 12, 4, 4],
};

filterStyles.orderNumberGridItem = {
    width: [12, 12, 12, 4, 4],
};

filterStyles.poNumberGridItem = {
    width: [12, 12, 12, 4, 4],
};

filterStyles.fromGridItem = {
    width: [6, 6, 6, 2, 2],
    css: css`
        width: 100%;
        display: flex;
        > div {
            width: 100%;
            display: flex;
        }
        ${xScreen("lte", constants.myAccountListPageFilter.breakpoints.xSmall)} {
            max-width: 100%;
            flex-basis: 100%;
        }
    `,
};
filterStyles.toGridItem = {
    width: [6, 6, 6, 2, 2],
    css: css`
        > div {
            width: 100%;
            display: flex;
        }
        ${xScreen("lte", constants.myAccountListPageFilter.breakpoints.xSmall)} {
            max-width: 100%;
            flex-basis: 100%;
        }
    `,
};

filterStyles.fromDate = {
    ...mergeWithCss(myAccountFilterSectionStyles.fromDate, {
        cssOverrides: {
            formInputWrapper: css`
                &&& {
                    .react-datetime-picker {
                        min-height: 42px;
                    }
                }
            `,
        },
    }),
};

filterStyles.toDate = {
    ...mergeWithCss(myAccountFilterSectionStyles.toDate, {
        cssOverrides: {
            formInputWrapper: css`
                &&& {
                    .react-datetime-picker {
                        min-height: 42px;
                    }
                }
            `,
        },
    }),
};

filterStyles.appliedFiltersContainer = {
    ...myAccountFilterSectionStyles.appliedFiltersContainer,
};

filterStyles.appliedFilterTag = {
    ...myAccountFilterSectionStyles.appliedFilterTag,
};
